app.service('productTabOpinions', function (console, loading, broker, productCardConfig, opinionForm, cookie, modal, message) {

	var $self,
		$opinionFilterModal,
		grade = false, 
		markers = [], loadedMarkers = [], isOpinionFilterModalInit = false;

	const OPINIONS_VOTES_COOKIE_NAME = 'opinions_votes';

	function loadSuccess(html, scroll){
		console.log('ZAŁADOWANIE ZAKŁADKI: OPINIE');
		$self.html(html);
		if(!$self.find('.empty-opinions-list').length) {
			updateOpinionsTabQuantity();
			grade = $self.find('#opinion-grade').val();
			grade = grade != '' ? grade/1 : false;
			markers = loadedMarkers = $self.find('#opinion-markers').val().split('|');
		}

		loading.stop();
		if (!scroll) {
			var hash = document.location.hash;
			if (hash == '#opinionFormAdd' || hash == '#opinionForm' || document.location.search.indexOf('mid=') > -1) {
				openOpinionForm();
			}
			if( hash.indexOf('#opinia-') === 0 ) {
				var opinionId = hash.slice(8);
				$.scrollTo( '#opinion-' + opinionId );
			}
		}
	}
	function loadError(){
		console.log('BŁĄD ŁADOWANIA ZAKŁADKI');
		$self.html('<div class="tab-error">Wystąpił błąd ładowania zakładki. Prosimy spróbować później</div>');
	}
	function findPageWithOpinion( hash ) {
		var config = productCardConfig.getData();
		var id = hash.match(/\d/g).join('');
		$.ajax({
			url:'/find-page-with-opinion.ltr',
			data:{
				productId:config.id,
				opinionId:id
			},
			success:function(json) {
				if( json.pageNumber ) {
					load(json.pageNumber, false);
				}
			}
		});
	}
	function load(page, scroll){
		if(typeof scroll === "undefined") {
			scroll = true;
		}
		if(!page){
			page=1;
			scroll=false;
		} else {
			loading.start();
		}
		if($self.length){
			$self.removeClass('adding-opinion');
			var config=productCardConfig.getData();
			var data={
				nodeid:config.nodeId,
				'product-link-name':config.linkName,
				page_nr:page,
				on_page:5,
				preview:config.preview
			};
			if(grade){
				data.grade=grade;
			}
			if(markers.length){
				data.opinionMarker=markers;
			}
			if(config.nodeId && config.linkName){
				$.ajax({
					url:'/product-card-opinion.ltr',
					data:data,
					success:function(html){
						loadSuccess(html, scroll);
					},
					error:function(){
						loadError();
					}
				});
			}
		}
	}
	function displayMoreAnswers() {
		var link=$(this);
		var answers = link.closest('.verified-answers');
		var maxAnswers = parseInt(link.data('max-answers'));
		var page = link.data('page');
		page = (page===undefined) ? 2 : parseInt(page)+1;
		answers.data('page', page).find('.answer:lt('+(maxAnswers*answersPage)+')').removeClass('none');
		if(!answers.find('.none').length) {
			link.hide();
		}
	}
	function loadGrade(newGrade) {
		grade = newGrade;
		load(1);
	}
	function openOpinionForm() {
		$self.addClass('adding-opinion');
		opinionForm.init();
	}
	function toggleContent($element) {
		$element.closest('.js-opinion-item').toggleClass('full-opinion');
	}

	function saveOpinionRate(data) {
		return $.ajax({
			url: '/opinion-update.ltr',
			type:'POST',
			cache: false,
			data
		})
	}

	function userHasAlreadyVoted(opinionId) {
		const opinions = cookie.isEmpty(OPINIONS_VOTES_COOKIE_NAME)
			? []
			: cookie.get(OPINIONS_VOTES_COOKIE_NAME).split('|');

		return opinions.indexOf(String(opinionId)) > -1;
	}

	function rememberUserVote(opinionId) {
		let opinions = cookie.isEmpty(OPINIONS_VOTES_COOKIE_NAME)
			? []
			: cookie.get(OPINIONS_VOTES_COOKIE_NAME).split('|');

		opinions.push(opinionId);

		cookie.set(OPINIONS_VOTES_COOKIE_NAME, opinions.join('|'), {
			path: '/',
			expires: 100
		});
	}

	function handleOpinionRate() {
		const opinionId = $(this).data('opinion-id');
		const opinion = $(this).data('opinion');

		if (userHasAlreadyVoted(opinionId)) {
			modal.alert('Już oceniałeś przydatność tej opinii.');
			return;
		}

		const opinionKey = opinion === 'helpful'
			? 'helpful'
			: 'notHelpful';

		saveOpinionRate({
			[opinionKey]: opinion,
			opinionId: opinionId
		});

		rememberUserVote(opinionId);

		let nextValue = +$(this).text() + 1;
		$(this).text(nextValue);
	}
	function updateOpinionsTabQuantity(){
		const loadedOpinionsQuantity = $self.find('[data-opinions-quantity]').data('opinions-quantity');
		broker.trigger('PRODUCT_OPINION_TAB_QUANTITY_CHANGE', loadedOpinionsQuantity);
	}
	function isFilterOpinionMarkerChanged(){
		return (JSON.stringify(markers) != JSON.stringify(loadedMarkers));
	}
	function loadFilterOpinionMarker(){
		grade=false; //reset previous grade filter
		UA.pageInteraction('Opinie', 'Filtruj - Wybrane rodzaje opinii: ' + markers);
		load(1);
	}
	function updateFilterButtonState(){
		const $applyFilterButtonParent= $opinionFilterModal.find('.opinion-filter-buttons-fixed');
		isFilterOpinionMarkerChanged() ? $applyFilterButtonParent.addClass('show-filter-apply-button') : $applyFilterButtonParent.removeClass('show-filter-apply-button');
	}
	function resetSelectedToLoadedMarkers(){
		if (isFilterOpinionMarkerChanged()) {
			$('.opinion-filter-buttons-fixed').removeClass('show-filter-apply-button'); // ukrycie przycisku filtrowania
			const $filterMarkerList = $('.opinion-filter-marker-list');
			//zaznaczenie załadowanych opcji
			markers = loadedMarkers;
			if (markers.length == 1) {
				$filterMarkerList.find('.opinion-filter-marker-option').removeClass('marker-selected marker-blocked');
				$filterMarkerList.find(`[data-marker="${markers[0]}"]`).addClass('marker-selected marker-blocked');
			} else if (markers.length > 1){
				$filterMarkerList.find('.marker-blocked').removeClass('marker-blocked');
				markers.forEach(function (marker) {
					$filterMarkerList.find(`[data-marker="${marker}"]`).addClass('marker-selected');
				});
			}
		}
	}

	function setEvents() {
		$self.on('click', '.js-opinion-rate', handleOpinionRate);

		$self.on('click', '.js-btn-paging', function() {
			load($(this).data('page'));
			UA.pageInteraction('Opinie', 'Stronicowanie - ' + $(this).data('page'));
		});

		$self.on('click', '.js-more-answers', function() {
			displayMoreAnswers();
		});

		$self.on('click', '.js-opinion-omnibus',function (e) {
			e.preventDefault();
			loading.start();
			message.get('omnibus-opinion-modal-message').then(function (html) {
				loading.stop();
				modal.generate({
					id: 'opinion-omnibus-modal',
					content: html,
					modifier: 'remodal-full-width'
				});
			})
		});

		$self.on('click', '.js-load-grade-opinion:not(.grade-no-results)', function() {
			loadGrade($(this).data('grade'));
			UA.pageInteraction('Opinie', 'Filtruj - ' + $(this).data('value'));
		});

		$self.on('click', '.js-add-opinion', function() {
			$(this)
				.closest('.opinion-buttons')
				.remove();
			openOpinionForm();
			UA.pageInteraction('Opinie', 'Dodaj opinię');
		});

		$self.on('click', '.js-opinion-toggle', function() {
			toggleContent($(this));
			UA.pageInteraction('Opinie', 'Rozwiń opinię');
		});

		$self.on('click', '.js-opinion-filter-marker-button', function() {
			resetSelectedToLoadedMarkers();
			modal.open('opinion-filter-marker-options', {
				modifier: 'remodal-full-width'
			})
			$opinionFilterModal = $('#modal-opinion-filter-marker-options');
			updateFilterButtonState();
			if(!isOpinionFilterModalInit) {
				$opinionFilterModal.on('click', '.js-opinion-filter-marker-option', function(){
					const $option = $(this);
					if( !$option.hasClass('marker-disabled') && !$option.hasClass('marker-blocked') ){
						$option.toggleClass('marker-selected');

						//aktualna lista zaznaczonych
						const $selectedOpinionMarkersList = $option.closest('.opinion-filter-marker-list').find('.marker-selected');

						if($selectedOpinionMarkersList.length == 1){//blokuje ostatnią opcję przed odznaczeniem
							$($selectedOpinionMarkersList[0]).addClass('marker-blocked');
						} else {
							$opinionFilterModal.find('[data-marker].marker-blocked').removeClass('marker-blocked');
						}

						markers = [];
						$selectedOpinionMarkersList.each((i,element) => {
							markers.push(element.dataset.marker);
						});
					}
					updateFilterButtonState();
					UA.interaction('KP - Modal', 'Opinie', 'Filtr rodzaju opinii ' + $option.data('marker') + ' klikniecie ');
				});
				$opinionFilterModal.on('click', '.js-opinion-filter-apply-button', function(){
					modal.close('opinion-filter-marker-options');
					loadFilterOpinionMarker();
				});
				isOpinionFilterModalInit = true;
			}
		});
	}

	function init(){
		$self=$('#opinions');
		setEvents();
		var hash = document.location.hash;
		if( hash.indexOf('#opinia-') === 0 ) {
			findPageWithOpinion( hash );
		} else {
			load();
		}
	}
	return {
		init:init
	};
});
